export const GET_USER_ASSESSMENTS = 'GET_USER_ASSESSMENTS'
export const GET_USER_ASSESSMENT_RESULTS = 'GET_USER_ASSESSMENT_RESULTS'
